import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const customQueueRoute: InvariantJiraRoute = {
	name: 'servicedesk-queues-custom-view',
	path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId',
	exact: true,
};
